import {Button, Stack, Typography} from '@mui/material'
import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {toast} from 'react-toastify'
import Vendor from '../../Api/vendor'
import {ForgetSchema} from '../../yup/vendorSchema'
import InputCode from './InputCode'
import MainBtn from '../customTable/MainBtn'
import ValidationFun from '../../yup/ValidationFun'
import ErrorMsg from '../customTable/NewMsgErr'
import PhoneInput from '../customTable/PhoneInput'
import {useSelector} from 'react-redux'
import {RootState} from '../../store'

function secondsUntil(waitUntil?: string) {
  if (!waitUntil) {
    return 0
  }
  return Math.max(0, Math.ceil((new Date(waitUntil).getTime() - Date.now()) / 1000))
}

export default function ForgetPassword({setIsActive, setCode, setPhone, value, setValue}: any) {
  const [userInfo, setUserInfo] = useState<any>({mobile: ''})

  const {t} = useTranslation()
  const [msgErr, setMsgErr] = React.useState<string>('')
  const [isLoading, setUsLoading] = React.useState(false)
  const [codeValue, setCodeValue] = useState<any>({})
  const [errors, setErrors] = useState<any>({})

  const handilForgetPassword = async (e: any) => {
    ValidationFun({...userInfo, phone_code: value}, ForgetSchema, setErrors, (value: any) => {
      Vendor.forgetPassword(
        {...userInfo, phone_code: value},
        () => {
          setPhone(userInfo.mobile)
          setMsgErr('')
          setUsLoading(false)
          set_is_true(false)
        },
        setUsLoading
      )
    })
  }
  const [is_true, set_is_true] = useState(true)
  const [isfocus, setFoucus] = useState('a')
  const [countdownSec, setCountdownSec] = useState(0)
  const [isResendDisabled, setIsResendDisabled] = useState(false)

  useEffect(() => {
    if (countdownSec <= 0) {
      setIsResendDisabled(false)
      return
    }
    const timerId = window.setInterval(() => {
      setCountdownSec((prev) => {
        if (prev <= 1) {
          window.clearInterval(timerId)
          setIsResendDisabled(false)
          return 0
        }
        return prev - 1
      })
    }, 1000)
    return () => window.clearInterval(timerId)
  }, [countdownSec > 0])

  const handleResend = () => {
    if (isResendDisabled || countdownSec > 0 || isLoading) {
      return
    }
    Vendor.resendOtp(
      {mobile: userInfo.mobile, phone_code: value},
      () => {
        setCountdownSec(0)
        setIsResendDisabled(false)
      },
      (body: any) => {
        const waitSec = secondsUntil(body?.wait_until)
        const minutes = Math.max(1, Math.ceil(waitSec / 60))
        toast.error(`Too many attempts. Try again in ${minutes} minutes`)
        setIsResendDisabled(true)
        setCountdownSec(waitSec || 15 * 60)
      },
      setUsLoading
    )
  }
  const sendCode = async (e?: any) => {
    e?.preventDefault?.()
    const isCode = ['a', 'b', 'c', 'd'].map((key) => String(codeValue[key] || '')).join('')
    if (isCode.length !== 4) {
      setMsgErr('code')
      return
    }
    Vendor.checkCode(
      {
        mobile: userInfo.mobile,
        phone_code: value,
        code: isCode,
      },
      () => {
        setCode(isCode)
        setPhone(userInfo.mobile)
        setIsActive(2)
        setMsgErr('')
      },
      setUsLoading
    )
  }
  const store = useSelector((state: RootState) => state.vender)
  const arrCode = ['a', 'b', 'c', 'd'] 
  return (
    <>
      {is_true ? (
        <form dir={store.isRtl==1?'rtl':'ltr'} style={{width: '100%'}} action=''>
          <Stack gap='20px'>
            <Typography sx={{fontSize: '24px', fontWeight: '600', textAlign: 'center'}}>
              {t('forgotPassword')}
            </Typography>
            <PhoneInput
              errors={errors}
              value={value}
              data={userInfo}
              setData={setUserInfo}
              name={'mobile'}
              setValue={setValue}
            />

            <Typography sx={{fontSize: '13px', color: '#3E97FF', fontWeight: '600'}}>
              <span style={{color: '#7E8299'}}>{t('back')} </span>{' '}
              <span
                onClick={() => {
                  setIsActive(0)
                }}
                style={{color: '#3E97FF', cursor: 'pointer'}}
              >
                {t('login')}
              </span>
            </Typography>
            <MainBtn
              br='8px'
              type='button'
              isLoading={isLoading}
              text={'submit'}
              handelSubmit={handilForgetPassword}
              disabled={isLoading}
            />
          </Stack>{' '}
        </form>
      ) : (
        <form dir={store.isRtl==1?'rtl':'ltr'} style={{width: '100%'}} action=''>
          <Stack gap='20px'>
            <Typography sx={{fontSize: '24px', fontWeight: '600', textAlign: 'center'}}>
              {t('resetPassword')}
            </Typography>
            <Stack>
              <Typography
                sx={{fontSize: '18px', fontWeight: '500', textAlign: 'center', color: '#A1A5B7'}}
              >
                {t('enterCode')}
              </Typography>
              <Typography sx={{fontSize: '18px', fontWeight: '600', textAlign: 'center'}}>
                {'*'.repeat(userInfo.mobile.length - 3) +
                  userInfo.mobile.substr(userInfo.mobile.length - 3)}
              </Typography>
            </Stack>
            <Stack gap='20px' justifyContent={'center'} direction={'row'}>
              {['a', 'b', 'c', 'd'].map((digitKey) => (
                <InputCode
                  key={digitKey}
                  isfocus={isfocus}
                  codeValue={codeValue}
                  e={digitKey}
                  setCodeValue={setCodeValue}
                  setFoucus={setFoucus}
                  arrCode={arrCode}
                  err={Boolean(msgErr)}
                />
              ))}
            </Stack>
            {msgErr ? <ErrorMsg msgErr={msgErr} /> : null}
            <Button
              type='button'
              disabled={isResendDisabled || countdownSec > 0 || isLoading}
              onClick={handleResend}
              sx={{
                alignSelf: 'flex-start',
                textTransform: 'none',
                color: '#3a9cf7',
                p: 0,
                minWidth: 0,
              }}
            >
              {countdownSec > 0 ? `Resend in ${countdownSec}s` : t('resend')}
            </Button>
            <MainBtn
              br='8px'
              type='button'
              text={'submit'}
              isLoading={isLoading}
              handelSubmit={sendCode}
              disabled={isLoading}
            />
          </Stack>{' '}
        </form>
      )}
    </>
  )
}
